/* eslint-disable */ 
export const simulateAwards = [
  '滴滴10元代金券',
  '滴滴10元代金券',
  '滴滴10元代金券',
  '滴滴10元代金券',
  '滴滴10元代金券',
  '爱奇艺会员月卡',
  '爱奇艺会员月卡',
  '爱奇艺会员月卡',
  '爱奇艺会员月卡',
  '1288金币',
  '1288金币',
  '1288金币',
  '1288金币',
  '1288金币',
  '1288金币',
  '1288金币',
  '1288金币',
  '1288金币',
  '1288金币',
  '百度网盘会员1月',
  '百度网盘会员1月',
  '百度网盘会员1月',
  '百度网盘会员1月',
  '百度网盘会员1月',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '20元通用优惠券',
  '京东卡100元',
  '京东卡100元',
  '京东卡100元',
  '第四代Kindle',
  '第四代Kindle',
  '小米小爱音箱',
  '小米小爱音箱',
  '小米小爱音箱',
  '小米小爱音箱',
];

export const simulatePortraits = [
  '0137e2421af3.jpg',
  '017302647550.jpg',
  '04343faa2e4d.jpg',
  '043a2d55b649.jpg',
  '048a4bea7c31.jpg',
  '051d7b04c2e9.jpg',
  '06b05d7f8258.jpg',
  '0710076baa82.jpg',
  '0732b1029ba6.png',
  '07dda025fd14.jpg',
  '093b92e92f67.jpg',
  '096522621a64.jpg',
  '09b776b7b221.jpg',
  '0b3210b82872.jpg',
  '0b88cdbb78e5.jpg',
  '0c314e0c6ca8.jpg',
  '0d33b5c4892b.jpg',
  '0d379354c538.jpg',
  '0ffbb2cf1241.jpg',
  '1376784f2842.jpg',
  '152a0a2f464b.jpg',
  '15534a2f8cca.jpg',
  '157988723b15.jpg',
  '16d3fa846aba.jpg',
  '16dec523a4be.png',
  '16f6b0e0c397.jpg',
  '16fdb5616322.jpg',
  '170875b1871e.png',
  '1774e627b336.jpg',
  '17da9ef7bedc.jpg',
  '17efaf41c0be.jpg',
  '1813f839c39b.png',
  '18ff647dbbfd.jpg',
  '19208257d259.jpg',
  '19313212b53e.jpg',
  '19d39627ccc3.jpg',
  '1a79faf33dc3.png',
  '1b5cc166167b.jpg',
  '1bb5be46d3d5.jpg',
  '1c8b42a0db36.jpg',
  '1ec482e59b66.jpg',
  '1fff8d466c53.png',
  '20d43037262d.jpg',
  '20ee6b2a862c.jpg',
  '20ef46845ad3.jpg',
  '223b8feff8fc.jpg',
  '22fab3c2b008.jpg',
  '232b227fc77a.jpg',
  '235ec3c66c9e.jpg',
  '25a5692f92e6.jpg',
  '2684bfbf9fb8.jpg',
  '275618a343a5.jpg',
  '276941ea181c.jpg',
  '276d66691dd1.jpg',
  '277dc070163f.png',
  '27c79ea812ff.jpg',
  '27de9d012be0.jpg',
  '2863da1a0717.jpg',
  '286bb946863f.jpg',
  '2acfc37cc3df.jpg',
  '30508321aba3.jpg',
  '309d12434252.jpg',
  '31cf521c262b.jpg',
  '327702a31028.png',
  '36bf37dc62f9.jpg',
  '36cf54f8eb61.jpg',
  '377bad7d3b59.jpg',
  '390f2d0d7839.jpg',
  '3936b6650e59.jpg',
  '39b18cbd59b0.jpg',
  '3a3137b98376.jpg',
  '3a887c2cc773.png',
  '3e35614d6b68.jpg',
  '437b00d0946c.png',
  '4482e275b733.jpg',
  '463019f5f727.jpg',
  '4650ca24c6d9.png',
  '4763530e3d83.jpg',
  '47951e1f9621.jpg',
  '4b21376f0a69.jpg',
  '4bd9bf37309c.jpg',
  '4bffe0f4452c.jpg',
  '4c611e2f8beb.jpg',
  '4d62aed04ee5.jpg',
  '4e4752625a83.jpg',
  '4ed7a0870805.jpg',
  '4edf9f379eb3.png',
  '4ef0337498f6.jpg',
  '4ff3bba8f5cf.jpg',
  '509eb3af4085.jpg',
  '5204f35e4a2f.jpg',
  '5319ff01219f.jpg',
  '531e83efefd4.png',
  '5328d044d13c.jpg',
  '5427cf4418c6.jpg',
  '55d9acb97f25.jpg',
  '562afc792db8.png',
  '59a7234be298.jpg',
  '5a55d98ece67.png',
  '5c76597506d9.jpg',
  '5e40755fb651.jpg',
  '5ea92f598392.png',
  '5fa6b8a9c689.jpg',
  '60090c9563d8.jpg',
  '6294d5ed9cb2.jpg',
  '63ad10f3d764.jpg',
  '644f7cd9e94f.png',
  '651e6d7fad8a.jpg',
  '6541dff280a1.jpg',
  '68f23b759642.png',
  '6a35489b43ff.png',
  '6a54410fdc25.jpg',
  '6a69a7e5e138.jpg',
  '6a7404678008.jpg',
  '6b4635889703.jpg',
  '6c9d2355cc9d.jpg',
  '6d00f216c0dd.png',
  '6efdb13779b9.jpg',
  '6f017ec54565.jpg',
  '6f6d7addc4d0.jpg',
  '71e4c57afcd0.jpg',
  '72323a52d4a4.jpg',
  '72b95bbddcd2.jpg',
  '7308259aaf10.jpg',
  '75be71f3d687.jpg',
  '7643f4d0f757.jpg',
  '766cc33cdc22.jpg',
  '7787b37f3207.jpg',
  '77dfd5d8590f.jpg',
  '7887225d1a2e.jpg',
  '78e4ee0bf547.jpg',
  '794a0819b0d7.jpg',
  '7955d71bfc93.jpg',
  '7a2495f852e6.jpg',
  '7ce39b59d7af.jpg',
  '7d8a36afca1b.jpg',
  '7e024da924ad.jpg',
  '7e3723d3a278.png',
  '7e48114169be.jpg',
  '7f40db3c2ea9.jpg',
  '7f5e4a2261d4.png',
  '7fa71291cd72.jpg',
  '80726b938e18.jpg',
  '80ac4e9ddea8.png',
  '81069f075426.jpg',
  '854b7cfb4838.jpg',
  '85c527d17296.png',
  '860383218cb4.png',
  '86c5acedcf2c.jpg',
  '8710584ab5b7.jpg',
  '892ab3a12ddb.jpg',
  '89304e396fee.jpg',
  '89c4d8ab6ba4.jpg',
  '8a0c699171e2.jpg',
  '8fd57644dcac.png',
  '91a775386231.jpg',
  '928b451097bb.jpg',
  '96f3c0649500.jpg',
  '9770284ea2a1.jpg',
  '981f2826c777.jpg',
  '99dc497875f9.jpg',
  '9b4fc0bcdd8f.jpg',
  '9c471f3d9a57.jpg',
  '9e9bf499b760.png',
  '9ef666c66737.jpg',
  '9eff3be2900f.jpg',
  'a012395b4afa.png',
  'a0305484ca51.jpg',
  'a120cd189f53.png',
  'a2ae085b6f1d.png',
  'a51cd1639254.jpg',
  'a67d4772d843.jpg',
  'a7ac0f62ab69.jpg',
  'a8fc7c726297.jpg',
  'a9da4a5580bd.png',
  'ab1e2407f6f4.jpg',
  'ab4ed3b15ea4.jpg',
  'abb013c0c390.jpg',
  'ac8891fae37a.png',
  'adbe5894a533.jpg',
  'ae6dc9b85a80.jpg',
  'af2d2a877020.jpg',
  'b05681e1d9ed.jpg',
  'b2ab683e9f71.png',
  'b2d70c6975c4.jpg',
  'b411e09d536f.jpg',
  'b415ad1602b8.jpg',
  'b427f3fefa2a.jpg',
  'b5121ec1d75e.png',
  'b550886ffe48.jpg',
  'b73f027f0cf3.jpg',
  'b9f5af40dfbb.jpg',
  'bb4860c02a9f.jpg',
  'bba5a9f869fa.jpg',
  'bc3dce67d1b1.jpg',
  'be48abcac288.jpg',
  'bf0a42662287.jpg',
  'bf2f2eb5e6f4.jpg',
  'bfbb34d1b9b0.jpg',
  'c381784702ec.jpg',
  'c4f4bb00af40.jpg',
  'c53ceb618fdd.jpg',
  'c61e22f65f61.jpg',
  'c6234e014171.jpg',
  'c6cd3c24939c.jpg',
  'c8240024a6d0.jpg',
  'c9122f37a081.jpg',
  'c9a108d9fdb9.jpg',
  'c9a4bbed98f5.jpg',
  'cb102100ea83.jpg',
  'cb6f963a0788.jpg',
  'cb7b81fbedbb.jpg',
  'cbf973520553.jpg',
  'cd8359472a12.jpg',
  'cdae518a925a.jpg',
  'd0623c9f58dd.jpg',
  'd111635a6525.jpg',
  'd21b32b112f6.jpg',
  'd3d03bd06280.jpg',
  'd5f9aac38f0c.jpg',
  'd9044a078e0d.jpg',
  'd9eb37a2a664.jpg',
  'da263a661a1b.jpg',
  'dadd7e8cd074.jpg',
  'dc2c37ed085b.jpg',
  'dd3a7e75bff6.jpg',
  'dd6e084fd4f3.jpg',
  'ddff4aef9900.jpg',
  'e0cc4d9384ab.jpg',
  'e0fca33d4094.jpg'
].map((value) => {
  return 'https://alcdn.yojiang.cn/lesson/groupbuy_portraits/' + value
});

export const simulateNicknames = [
  '梦幻之露',
  '梦忆沐歌',
  '魅影之心',
  '流云如水',
  '桃萌萌∞',
  '浮光之海＊',
  '静水深流',
  '动感超人的小光波',
  '啵啵虎的大白牙′ノ`*',
  '看着你幸福啊め',
  '小无敌',
  '待谢繁草',
  '许我半盏清茶',
  '二十四桥明月夜',
  '旧颜',
  '朂孰悉哋帞泩亾',
  '岁月了然',
  '孤祭。',
  '情话说给左耳听',
  '樱花再美终会凋零',
  '瑾凉',
  '休辜负',
  '转角预定愛*',
  '寻沫雨悠扬',
  '若水微香',
  '帘外雨',
  '人命薄',
  '旧旧de回忆',
  '最后一滴泪',
  '自由族灬红泪ツ',
  '苁茈⒈個朲辵',
  '演绎悲伤。',
  '何时心不花',
  '温良情境',
  '我们未曾长不大ζ,',
  '软妹咿呀哟',
  'ó米朵喵ッ',
  '浪┑┏稚幼女心＝＝',
  '萌鹿背上的小奶包_',
  '清酒孤灯',
  '心有不甘',
  '南城北巷',
  '枫林觅影e',
  '云端的琴声',
  '§听风§',
  '素颜|红妆',
  '做个万人宠',
  '一人我干净利落',
  '一个人的天空`',
  '夏花里的深绿木',
  '江南未寒',
  '好吃の软妹',
  '全网最萌打怪小能手',
  '扶弦',
  '三秋远',
  '罐头告诉猫',
  '手捧软喵メ',
  '觅遇',
  '太阳暖人不暖心',
  '阿萌妹',
  'ご霸道妹纸ミ',
  '妍如玉',
  '资深神经病患者',
  '女为悦己者整容',
  '熊猫宝贝',
  '纯情的小太阳',
  '…饮料味软妹>﹏<。',
  '贪新厌旧',
  '掉价行为',
  '所有悲戚',
  '摇清碎影',
  '离愁尽在不言中',
  '夏木悠悠',
  '夏风不燥',
  '宠溺Dē愛﹪',
  '┽﹏甜心公主',
  '豹纹小袜袜',
  '呆萌暖暖吐舌头',
  '糖果味的爱恋',
  '玩飞车滴孩子我陪你',
  '还要编多少个理由゜',
  '清竹雅韵',
  '煙花消逝ぐ記憶殘',
  '时光向来煞人',
  '墨染°青衣颜メ',
  '嘴角挂着玩味',
  '阳光照亮一切',
  '勾勾手指',
  '等到天蓝再看海',
  'つ',
  '蒲公英和纸飞机*',
  '我已绝版请珍惜',
  '若不愛π_π请放手',
  '暗月苍穹',
  '三十六度阳光¤',
  '青丝茧',
  '明若轻兮',
  '最美的时光。',
  '泪洒曦晨绝韶华ヾ',
  '薄荷与夏天',
  '身野稳浪场°',
  '薄荷之夜り微微涼',
  '持刀砍净天下婊',
  '花落尘归去',
  '孤傲残雪',
  '北辰浅巷墨漓',
  '花落若相惜',
  '不良女帝',
  '白色幻影',
  '爱的模样',
  '眼睛流汗了',
  '无人迁就',
  '无言的对白',
  '习惯了就好',
  '心药难意',
  '习惯了你的沉默',
  '梦入晚花',
  '斜阳下微笑',
  '雨不眠的夜',
  '落樱纷飞',
  '单只小蝴蝶',
  '一朵向阳花',
  '茉莉花凉',
  '幸运烟雨',
  '烟雨爱与毁',
  '把真心藏好',
  '败给温柔',
  '苍了微凉',
  '喜欢你的暧昧',
  '想和你爱爱',
  '乘风破浪',
  '出卖心动',
  '穿草裙的美女',
  '心中的希望',
  '纯粹的爱恋',
  '此夜此月',
  '干净月光,',
  '幽蓝紫蝶',
  '风雨一夜',
  '廉价败类',
  '干净利落',
  '孤心好感',
  '清尘在雨季',
  '寂寞花儿开',
  '话在心里',
  '回忆的夏天',
  '时光凉透',
  '喜欢长歌',
  '几度几分',
  '尽揽风月',
  '静待花开',
  '孤海微凉',
  '淮南柚香',
  '迷彩上的格桑花',
  '好害羞的指挥官',
  '蓝涩雨蝶',
  '帘卷声寂',
  '红得思春期',
  '两相倚情人',
  '两小无猜',
  '浮生缥缈',
  '绿水无忧',
  '纷飞的雪',
  '可爱迟暮',
  '漫天美人',
  '末路陌路',
  '天空菊花',
  '笑在眉眼',
  '暖风撩人',
  '千夕何处寻',
  '半夏浅凝',
  '浅夏初晴',
  '青梅煮马',
  '瘦马淡雾',
  '小仙女',
  '清晨清风',
  '情感清颜',
  '晴天飞雪',
  '人心可畏',
  '柔情暴徒',
  '风爱大笑',
  '喜欢无恙',
  '少女心事',
  '失心疯',
  '雨伞风听',
  '新鲜感觉',
  '甜的正经',
  '甜味超标',
  '惋惜丢了',
  '撩情高手',
  '拥你入怀',
  '北港孤人',
  '北栀海',
  '情书与你i',
  '南巷清风',
  '北幕南辞°',
  '北方故事',
  '力竭也奉陪',
  '一曲诀别诗.',
  '陈年的余热',
  '海在阳光下⌒',
  '南顾生烟'
];
